export const shadows = {
    none: 'none',
    light: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    sheet: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    modal: '0px 9px 28px rgba(0, 0, 0, 0.25)',
} as const;
